module.exports = __webpack_public_path__ + "static/media/no.a9024185.svg";